import { render, staticRenderFns } from "./Familia.vue?vue&type=template&id=5942e6da"
import script from "./Familia.vue?vue&type=script&lang=js"
export * from "./Familia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports